import React from 'react';
import { RootStateOrAny } from 'react-redux';
import { store } from '../Redux/store';
import { Server } from '../Platform/Server';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { AVAuth } from '../Platform/AVAuth';
import _ from 'lodash';
import ToastMessage from './useAlertToast';
import { setAlertState, setNewAlerts } from "../Redux/Actions/alertActions";
import { setFeedsState } from "../Redux/Actions/feedsAction";
import { setConvoState } from "../Redux/Actions/convoActions";
import { setresetState } from "../Redux/Actions/userActions";
import { Alert } from '../AVCore/Alert';

export const getAlertFetcher = async () =>
{
    async function fetchAlertsOnEvery30secs ( notificationEnabled )
    {
        let fetchInterval;
        fetchInterval = setInterval( () =>
        {
            if ( document.visibilityState === 'visible' )
            {
                console.log( 'Get alert on every 30secs...' );
                fetchAlertsOnfocus( notificationEnabled );
            }
        }, 30000 );
    }

    async function fetchAlertsOnfocus ( notificationEnabled )
    {

        console.log( "notificationEnabled....", notificationEnabled );
        const reduxstate : RootStateOrAny = store.getState();
        const { alerts, user } = reduxstate;
        const userdata = AVAuth.currentUser();
        if ( userdata == undefined )
        {
            store.dispatch( setAlertState() );
            store.dispatch( setConvoState() );
            store.dispatch( setFeedsState() );
            store.dispatch( setresetState() );
            return;
        }
        let alertsval = alerts.alert[ 0 ];
        if ( alertsval == undefined )
            alertsval = [];

        if (!notificationEnabled)
        {
            const existingAlertIds = new Set( alertsval?.map( alert => alert?.id ) );
            Alert.GetAlerts().then( x =>
            {
                var alertList : any = x;
                alertList?.sort( function ( a, b )
                {
                    let c : any = new Date( b.date );
                    let d : any = new Date( a.date );
                    return d - c;
                } );
                if ( alertList?.length > 0 )
                {
                    for ( const alert of alertList )
                    {
                        if ( !existingAlertIds?.has( alert?.id ) && alert?.actionTaken !== 'Viewed' )
                        {
                            alertsval.unshift( alert );

                            store.dispatch( setNewAlerts( [ alert ] ) );
                            existingAlertIds.add( alert.id );
                        } else if ( alert?.actionTaken !== undefined && alert?.actionTaken !== 'Viewed' && !existingAlertIds?.has( alert?.id ) )
                        {
                            const existingAlertIndex = alertsval?.findIndex( existingAlert => existingAlert?.id === alert?.id );
                            if ( existingAlertIndex !== -1 )
                            {
                                alertsval.splice( existingAlertIndex, 1 );
                                alertsval.unshift( alert );
                                let ToastAlert = { type: alert?.alertType }
                                ToastMessage( { ToastAlert } );
                                console.log( "Toast 3" );
                                store.dispatch( setNewAlerts( [ alert ] ) );
                            }
                        }
                    }

                }
            } )
        }
    }

    return { fetchAlertsOnfocus, fetchAlertsOnEvery30secs };
};
